<template>
  <div
    v-if="visible"
    class="cs-modal-backdrop"
    role="dialog"
    aria-modal="true"
    aria-label="Pintasan keyboard"
    data-component-id="chat--shortcuts--modal"
    @click.self="$emit('close')"
  >
    <div class="cs-modal" @keydown.esc="$emit('close')">
      <div class="cs-modal-head">
        <span class="cs-modal-title">⌨️ Pintasan Keyboard</span>
        <button class="cs-modal-close" @click="$emit('close')" aria-label="Tutup">✕</button>
      </div>
      <div class="cs-modal-body">
        <div v-for="group in shortcuts" :key="group.title" class="cs-group">
          <div class="cs-group-title">{{ group.title }}</div>
          <div v-for="(s, i) in group.items" :key="i" class="cs-row">
            <span class="cs-keys">
              <kbd v-for="(k, ki) in s.keys" :key="ki">{{ k }}</kbd>
            </span>
            <span class="cs-desc">{{ s.desc }}</span>
          </div>
        </div>
      </div>
      <div class="cs-modal-foot">
        Tekan <kbd>?</kbd> atau <kbd>Esc</kbd> untuk tutup
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  visible: { type: Boolean, default: false },
})
defineEmits(['close'])

const shortcuts = [
  {
    title: 'Pesan',
    items: [
      { keys: ['Enter'],          desc: 'Kirim pesan' },
      { keys: ['Shift', 'Enter'], desc: 'Baris baru' },
      { keys: ['Esc'],            desc: 'Hentikan streaming / tutup panel' },
    ],
  },
  {
    title: 'Sesi',
    items: [
      { keys: ['Ctrl', 'K'], desc: 'Buka/tutup riwayat percakapan' },
      { keys: ['Ctrl', 'N'], desc: 'Mulai percakapan baru' },
    ],
  },
  {
    title: 'Navigasi Pertanyaan',
    items: [
      { keys: ['['], desc: 'Lompat ke pertanyaan sebelumnya (Q-)' },
      { keys: [']'], desc: 'Lompat ke pertanyaan berikutnya (Q+)' },
    ],
  },
  {
    title: 'Lainnya',
    items: [
      { keys: ['?'],         desc: 'Tampilkan pintasan ini' },
      { keys: ['Ctrl', 'D'], desc: 'Unduh percakapan (.md)' },
    ],
  },
]
</script>

<style scoped>
.cs-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: cs-fade-in 0.18s ease-out;
}
@keyframes cs-fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.cs-modal {
  background: var(--bg-elev, var(--bg-card));
  border: 1px solid var(--border, var(--border-light));
  border-radius: 10px;
  width: 90%;
  max-width: 460px;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px -10px rgba(0, 0, 0, 0.6);
  animation: cs-slide-up 0.22s ease-out;
}
@keyframes cs-slide-up {
  from { transform: translateY(12px); opacity: 0; }
  to   { transform: translateY(0);     opacity: 1; }
}

.cs-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border-soft, var(--border-light));
}
.cs-modal-title {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text-primary, var(--text-body));
}
.cs-modal-close {
  background: transparent;
  border: 1px solid var(--border-soft, var(--border-light));
  color: var(--text-base, var(--text-body));
  width: 26px;
  height: 26px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cs-modal-close:hover {
  background: var(--bg-hover, var(--bg-hover));
  color: var(--accent-red, #ef4444);
}

.cs-modal-body {
  padding: 12px 14px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.cs-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cs-group-title {
  font-size: 10.5px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--text-dim, #6b7a8d);
  font-weight: 600;
  margin-bottom: 4px;
}
.cs-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 5px 0;
  font-size: 12px;
}
.cs-keys {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
}
.cs-keys kbd,
.cs-modal-foot kbd {
  display: inline-block;
  padding: 2px 7px;
  border: 1px solid var(--border-soft, var(--border-light));
  background: var(--bg-base, var(--bg-deep));
  border-radius: 4px;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 10.5px;
  color: var(--text-base, var(--text-body));
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  line-height: 1;
}
.cs-desc {
  color: var(--text-base, var(--text-body));
  text-align: right;
}

.cs-modal-foot {
  padding: 9px 14px;
  border-top: 1px solid var(--border-soft, var(--border-light));
  font-size: 10.5px;
  color: var(--text-dim, #6b7a8d);
  text-align: center;
  background: var(--bg-base, var(--bg-deep));
}
</style>
